import _isNumber from 'lodash/isNumber';
export function isNumber(value) {
    return ![NaN, Infinity, '', null, undefined].includes(value) && _isNumber(value);
}
